<div class="addon-quantity-selector-modal-bg" (click)="close()" @opacityInOut></div>
<div class="addon-quantity-selector-modal" @scaleInOut>
  <i class="app-ico-mask app-ico-mask__x" (click)="close()"></i>

  <h2>{{ title }}</h2>
  <p *ngIf="description">{{ description }}</p>

  <div class="addon-quantity-selector-modal__input-wrapper">
    <a-input type="number" [label]="'AddOns.Quantity' | translate" [control]="quantityControl"
      [isSubmitted]="showErrors" [errorMessage]="getErrorMessage()">
    </a-input>
  </div>

  <div class="addon-quantity-selector-modal__btns">
    <div class="is-btn is-btn__outfill" (click)="close()">{{ 'Common.Cancel' | translate }}</div>
    <div class="is-btn" [class.is-disabled]="quantityControl.invalid" (click)="confirm()">
      {{ 'Common.Add' | translate }}
    </div>
  </div>
</div>
